import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { default as collaboration } from "../../assets/clloborations.jpg"
import { theme } from "../../common/style/Theme";
import { CheckCircle, Business, Psychology, TrendingUp, IntegrationInstructions, Speed, FlashOn, Sync, EmojiEvents } from "@mui/icons-material";

const Collaborations = () => {
    // Responsive breakpoints
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    // Add floating animation styles
    const floatingAnimation = `
        @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            33% { transform: translateY(-20px) rotate(120deg); }
            66% { transform: translateY(-10px) rotate(240deg); }
        }
    `;

    // Inject styles
    if (typeof document !== 'undefined') {
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = floatingAnimation;
        document.head.appendChild(styleSheet);
    }

    const collbortionReasons = [
        "Delegate effectively without diluting accountability",
        "Leverage specialized skills from partners with deep domain experience",
        "Accelerate execution without compromising quality",
        "Adapt quickly to evolving client requirements"
    ]

    const philosophyPoints = [
        {
            title: "Clear Module Assignment",
            description: "We assign modules or microservices with clear documentation, scope, and timelines"
        },
        {
            title: "Partnership Approach",
            description: "Partners are treated as project stakeholders, not vendors"
        },
        {
            title: "Streamlined Communication",
            description: "Communication is streamlined, and dependencies are kept minimal"
        },
        {
            title: "Joint Quality Assurance",
            description: "Quality, integration, and testing are handled jointly for smooth delivery"
        }
    ]

    const partnerAdvantages = [
        {
            icon: Business,
            title: "Consistent Workflows",
            description: "Get regular, well-defined projects that match your core competencies"
        },
        {
            icon: IntegrationInstructions,
            title: "Seamless Integration",
            description: "Our modular development approach ensures easy plug-and-play integration"
        },
        {
            icon: Speed,
            title: "Faster Turnarounds",
            description: "Work in parallel on different modules—delivery never waits"
        },
        {
            icon: Psychology,
            title: "Shared Intelligence",
            description: "Access to solution architecture, tech know-how, and shared tools"
        },
        {
            icon: TrendingUp,
            title: "Opportunities to Scale",
            description: "Long-term partnerships that grow with mutual success"
        }
    ]

    return (
        <Box>
            <Box style={{
                width: "100vw",
                height: isMobile ? "50vh" : "60vh",
                position: "relative"
            }}>
                <img src={collaboration} alt="collaborations"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center"
                    }} 
                />
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.75)"
                }}/>
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                }}>
                    <Box style={{
                        color: theme.palette.common.white,
                        padding: "10vw 8vw 8vw 8vw",
                        textAlign: "center"
                    }}>
                        <Typography variant={isMobile ? "h3" : "h1"} style={{
                            textAlign: "center",
                            marginBottom: "20px",
                            fontSize: isMobile ? "2rem" : isTablet ? "2.5rem" : undefined
                        }}>
                            Collaborations
                        </Typography>
                        <Typography variant="body1" style={{
                            textAlign: "center",
                            fontSize: isMobile ? "0.95rem" : isTablet ? "1rem" : "1.1rem",
                            lineHeight: isMobile ? "1.6" : "1.7",
                            maxWidth: "900px",
                            margin: "0 auto"
                        }}>
                            At M5 Info Solutions, we believe in the power of collaborative growth. In a dynamic digital landscape where speed, efficiency, and innovation are critical, partnerships play a vital role in creating scalable and reliable technology solutions. We actively collaborate with small and mid-sized companies, independent developers, and specialized tech firms to co-create value with minimal dependency and maximum agility.
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Grid container style={{
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Grid size={{xs: 12, sm: 12, md: 4, lg: 4}}>
                    <Typography variant={isMobile ? "h4" : "h2"} style={{
                        textAlign: "center", 
                        marginBottom: "20px", 
                        color: theme.palette.secondary.main,
                        fontSize: isMobile ? "1.8rem" : isTablet ? "2.2rem" : undefined
                    }}>
                        Why We Collaborate?
                    </Typography>
                    <Typography variant="body1" style={{
                        textAlign: "center",
                        fontSize: isMobile ? "0.95rem" : "1rem",
                        lineHeight: isMobile ? "1.6" : "1.7"
                    }}>
                        Every project is unique—and so are the skills and perspectives required to build it. By forming strategic alliances, M5 ensures that no opportunity is missed due to bandwidth constraints or niche expertise requirements. Collaboration allows us to:
                    </Typography>
                </Grid>
                <Grid size={{xs: 12, sm: 12, md: 8, lg: 8}} style={{
                    paddingLeft: isMobile ? "0" : "5vw",
                    marginTop: isMobile ? "30px" : "0"
                }}>
                        {collbortionReasons.map((reason, index) => (
                            <Box key={index} style={{
                                background: theme.palette.common.white,
                                padding: isMobile ? "15px 20px" : "1vw",
                                borderRadius: "10px",
                                boxShadow: "0 8px 32px rgba(23, 21, 128, 0.08)",
                                margin: isMobile ? "15px 0" : "1vw",
                                position: "relative"
                            }}>
                                <Box style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "5px",
                                    height: "100%",
                                    borderRadius: "10px 0 10px 0",
                                    background: `linear-gradient(55deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                }} />
                                <Typography variant="body1" style={{
                                    textAlign: "left",
                                    color: theme.palette.text.primary,
                                    fontSize: isMobile ? "14px" : "16px",
                                    lineHeight: "1.6",
                                    fontWeight: 500,
                                    margin: 0,
                                    paddingLeft: "15px"
                                }}>
                                    {reason}
                                </Typography>
                            </Box>
                        ))}
                </Grid>
            </Grid>
            <Box style={{
                background: `linear-gradient(135deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}10)`,
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                position: "relative",
                overflow: "hidden"
            }}>
                <Box style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    background: `linear-gradient(45deg, ${theme.palette.secondary.main}20, ${theme.palette.primary.main}15)`,
                    filter: "blur(40px)",
                    zIndex: 0
                }} />
                <Box style={{
                    position: "absolute",
                    bottom: "-100px",
                    left: "-100px",
                    width: "300px",
                    height: "300px",
                    borderRadius: "50%",
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}10)`,
                    filter: "blur(60px)",
                    zIndex: 0
                }} />
                
                <Grid container spacing={4} style={{ position: "relative", zIndex: 1 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <Typography variant={isMobile ? "h4" : "h2"} style={{
                            textAlign: "center",
                            marginBottom: isMobile ? "30px" : "40px",
                            color: theme.palette.secondary.main,
                            fontWeight: 700,
                            fontSize: isMobile ? "1.8rem" : isTablet ? "2.2rem" : undefined,
                            background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text"
                        }}>
                            Our Collaboration Philosophy
                        </Typography>
                        <Typography variant="body1" style={{
                            textAlign: "center",
                            marginBottom: isMobile ? "40px" : "50px",
                            fontSize: isMobile ? "1rem" : "1.1rem",
                            lineHeight: "1.7",
                            color: theme.palette.text.primary,
                            maxWidth: "800px",
                            margin: `0 auto ${isMobile ? "40px" : "50px"} auto`
                        }}>
                            We don't believe in one-size-fits-all outsourcing. Our collaboration model is mutual, transparent, and growth-oriented:
                        </Typography>
                    </Grid>
                    <Grid container spacing={isMobile ? 3 : 4}>
                        {philosophyPoints.map((point, index) => (
                            <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 6 }} style={{
                                display: "flex",
                                justifyContent: "center"
                            }}>
                                <Box style={{
                                    background: theme.palette.common.white,
                                    padding: isMobile ? "25px 20px" : "35px 30px",
                                    borderRadius: "16px",
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                                    border: `1px solid ${theme.palette.primary.main}20`,
                                    position: "relative",
                                    width: "100%",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    cursor: "pointer",
                                    "&:hover": {
                                        transform: "translateY(-8px)",
                                        boxShadow: "0 16px 48px rgba(0, 0, 0, 0.12)"
                                    }
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-8px)";
                                    e.currentTarget.style.boxShadow = "0 16px 48px rgba(0, 0, 0, 0.12)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.08)";
                                }}>
                                    <Box style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        height: "4px",
                                        borderRadius: "16px 16px 0 0",
                                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`
                                    }} />
                                    <Box style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "15px"
                                    }}>
                                        <Box style={{
                                            width: isMobile ? "40px" : "48px",
                                            height: isMobile ? "40px" : "48px",
                                            borderRadius: "12px",
                                            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                            boxShadow: `0 4px 16px ${theme.palette.primary.main}30`
                                        }}>
                                            <CheckCircle style={{
                                                color: theme.palette.common.white,
                                                fontSize: isMobile ? "20px" : "24px"
                                            }} />
                                        </Box>
                                        
                                        <Box style={{ flex: 1 }}>
                                            <Typography variant="h6" style={{
                                                fontWeight: 600,
                                                marginBottom: "10px",
                                                color: theme.palette.text.primary,
                                                fontSize: isMobile ? "1.1rem" : "1.25rem",
                                                lineHeight: "1.3"
                                            }}>
                                                {point.title}
                                            </Typography>
                                            <Typography variant="body2" style={{
                                                color: theme.palette.text.secondary,
                                                lineHeight: "1.6",
                                                fontSize: isMobile ? "0.9rem" : "1rem"
                                            }}>
                                                {point.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Box>
            
            {/* Key Advantages for Our Partners Section */}
            <Box style={{
                background: `linear-gradient(160deg, ${theme.palette.common.white}, ${theme.palette.primary.main}08)`,
                padding: isMobile ? "8vw 5vw" : isTablet ? "6vw 8vw" : "5vw 10vw",
                position: "relative",
                overflow: "hidden"
            }}>
                {/* Animated background elements */}
                <Box style={{
                    position: "absolute",
                    top: "10%",
                    left: "5%",
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    background: `radial-gradient(circle, ${theme.palette.secondary.main}25, transparent 70%)`,
                    animation: "float 6s ease-in-out infinite",
                    zIndex: 0
                }} />
                <Box style={{
                    position: "absolute",
                    bottom: "15%",
                    right: "8%",
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: `radial-gradient(circle, ${theme.palette.primary.main}20, transparent 70%)`,
                    animation: "float 8s ease-in-out infinite reverse",
                    zIndex: 0
                }} />
                
                <Grid container style={{ position: "relative", zIndex: 1 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <Typography variant={isMobile ? "h4" : "h2"} style={{
                            textAlign: "center",
                            marginBottom: isMobile ? "20px" : "30px",
                            color: theme.palette.secondary.main,
                            fontWeight: 700,
                            fontSize: isMobile ? "1.8rem" : isTablet ? "2.2rem" : undefined
                        }}>
                            Key Advantages for Our Partners
                        </Typography>
                        
                        {/* Advantages Grid */}
                        <Grid container spacing={isMobile ? 3 : 4} style={{ 
                            marginBottom: isMobile ? "40px" : "60px",
                            justifyContent: "center"
                        }}>
                            {partnerAdvantages.map((advantage, index) => (
                                <Grid key={index} size={{ 
                                    xs: 12, 
                                    sm: 6, 
                                    md: 4, 
                                    lg: 4 
                                }} style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    ...(index >= 3 && !isMobile && !isTablet && {
                                        maxWidth: "33.333333%"
                                    })
                                }}>
                                    <Box style={{
                                        background: theme.palette.common.white,
                                        padding: isMobile ? "25px 20px" : "30px 25px",
                                        borderRadius: "20px",
                                        boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                                        border: `2px solid ${theme.palette.primary.main}15`,
                                        position: "relative",
                                        width: "100%",
                                        height: isMobile ? "auto" : "200px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                        cursor: "pointer",
                                        overflow: "hidden"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-12px) scale(1.02)";
                                        e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)";
                                        e.currentTarget.style.borderColor = theme.palette.secondary.main + "40";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0) scale(1)";
                                        e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)";
                                        e.currentTarget.style.borderColor = theme.palette.primary.main + "15";
                                    }}>
                                        {/* Floating gradient background */}
                                        <Box style={{
                                            position: "absolute",
                                            top: "-50%",
                                            left: "-50%",
                                            width: "200%",
                                            height: "200%",
                                            background: `linear-gradient(45deg, ${theme.palette.primary.main}05, ${theme.palette.secondary.main}05)`,
                                            borderRadius: "50%",
                                            opacity: 0,
                                            transition: "opacity 0.3s ease",
                                            zIndex: 0
                                        }} />
                                        
                                        {/* Icon container */}
                                        <Box style={{
                                            width: isMobile ? "60px" : "70px",
                                            height: isMobile ? "60px" : "70px",
                                            borderRadius: "20px",
                                            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "20px",
                                            boxShadow: `0 8px 24px ${theme.palette.primary.main}40`,
                                            position: "relative",
                                            zIndex: 1,
                                            transition: "all 0.3s ease"
                                        }}>
                                            <advantage.icon style={{
                                                color: theme.palette.common.white,
                                                fontSize: isMobile ? "28px" : "32px"
                                            }} />
                                        </Box>
                                        
                                        {/* Content */}
                                        <Box style={{ position: "relative", zIndex: 1, flex: 1 }}>
                                            <Typography variant="h6" style={{
                                                fontWeight: 600,
                                                marginBottom: "12px",
                                                color: theme.palette.text.primary,
                                                fontSize: isMobile ? "1.1rem" : "1.2rem",
                                                lineHeight: "1.3"
                                            }}>
                                                {advantage.title}
                                            </Typography>
                                            <Typography variant="body2" style={{
                                                color: theme.palette.text.secondary,
                                                lineHeight: "1.5",
                                                fontSize: isMobile ? "0.9rem" : "0.95rem"
                                            }}>
                                                {advantage.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                        {/* Bottom highlight section */}
                        <Box style={{
                            background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
                            padding: isMobile ? "30px 25px" : "40px 50px",
                            borderRadius: "24px",
                            position: "relative",
                            overflow: "hidden",
                            boxShadow: "0 16px 48px rgba(0, 0, 0, 0.1)"
                        }}>
                            {/* Animated pattern overlay */}
                            <Box style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: `repeating-linear-gradient(
                                    45deg,
                                    transparent,
                                    transparent 2px,
                                    rgba(255,255,255,0.1) 2px,
                                    rgba(255,255,255,0.1) 4px
                                )`,
                                opacity: 0.3,
                                zIndex: 0
                            }} />
                            
                            <Box style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                                <Typography variant={isMobile ? "h5" : "h4"} style={{
                                    color: theme.palette.common.white,
                                    fontWeight: 700,
                                    marginBottom: isMobile ? "15px" : "20px",
                                    fontSize: isMobile ? "1.4rem" : "1.8rem",
                                    textShadow: "0 2px 4px rgba(0,0,0,0.3)"
                                }}>
                                    Seamless Integration. Fast Delivery. No Bottlenecks.
                                </Typography>
                                <Typography variant="body1" style={{
                                    color: theme.palette.common.white,
                                    fontSize: isMobile ? "1rem" : "1.1rem",
                                    lineHeight: "1.7",
                                    opacity: 0.95,
                                    maxWidth: "900px",
                                    margin: "0 auto"
                                }}>
                                    Whether it's building a component of an ERP system, integrating with a third-party service, or developing a mobile module—M5 ensures that your work integrates into the larger picture effortlessly. Our teams provide technical clarity, testing environments, and integration support to ensure delivery is always on time, and always on point.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            
            {/* Looking to Collaborate Section */}
            <Box style={{
                background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
                padding: isMobile ? "10vw 5vw" : isTablet ? "8vw 8vw" : "6vw 10vw",
                position: "relative",
                overflow: "hidden"
            }}>
                {/* Animated background patterns */}
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `repeating-linear-gradient(
                        120deg,
                        transparent,
                        transparent 20px,
                        rgba(255,255,255,0.05) 20px,
                        rgba(255,255,255,0.05) 40px
                    )`,
                    zIndex: 0
                }} />
                
                {/* Floating elements for visual appeal */}
                <Box style={{
                    position: "absolute",
                    top: "20%",
                    right: "10%",
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    animation: "float 10s ease-in-out infinite",
                    zIndex: 0
                }} />
                <Box style={{
                    position: "absolute",
                    bottom: "25%",
                    left: "15%",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.08)",
                    animation: "float 12s ease-in-out infinite reverse",
                    zIndex: 0
                }} />
                
                <Box style={{
                    position: "relative",
                    zIndex: 1,
                    textAlign: "center",
                    maxWidth: "900px",
                    margin: "0 auto"
                }}>
                    <Typography variant={isMobile ? "h3" : "h2"} style={{
                        color: theme.palette.common.white,
                        fontWeight: 700,
                        marginBottom: isMobile ? "25px" : "35px",
                        fontSize: isMobile ? "2rem" : isTablet ? "2.5rem" : "3rem",
                        textShadow: "0 4px 8px rgba(0,0,0,0.3)",
                        lineHeight: "1.2"
                    }}>
                        Looking to Collaborate?
                    </Typography>
                    
                    <Typography variant="body1" style={{
                        color: theme.palette.common.white,
                        lineHeight: "1.8",
                        marginBottom: isMobile ? "35px" : "45px",
                        opacity: 0.95,
                        textShadow: "0 2px 4px rgba(0,0,0,0.2)"
                    }}>
                        If you're a development agency, a product company, or a domain-specific tech team looking for collaborative opportunities, we'd love to hear from you. Let's build together—with speed, synergy, and shared success.
                    </Typography>
                    
                    {/* Call-to-action highlight box */}
                    <Box style={{
                        background: "rgba(255,255,255,0.15)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.2)",
                        borderRadius: "20px",
                        padding: isMobile ? "25px 20px" : "35px 40px",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                        position: "relative",
                        overflow: "hidden"
                    }}>
                        {/* Inner glow effect */}
                        <Box style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))",
                            borderRadius: "20px",
                            zIndex: 0
                        }} />
                        
                        <Box style={{ position: "relative", zIndex: 1 }}>
                            <Typography variant={isMobile ? "h5" : "h4"} style={{
                                color: theme.palette.common.white,
                                fontWeight: 600,
                                marginBottom: isMobile ? "15px" : "20px",
                                fontSize: isMobile ? "1.3rem" : "1.6rem",
                                textShadow: "0 2px 4px rgba(0,0,0,0.3)"
                            }}>
                                🤝 Ready to Start Building Together?
                            </Typography>
                            
                            <Typography variant="body1" style={{
                                color: theme.palette.common.white,
                                fontSize: isMobile ? "1rem" : "1.1rem",
                                lineHeight: "1.6",
                                opacity: 0.9,
                                marginBottom: isMobile ? "25px" : "30px"
                            }}>
                                Join our network of collaborative partners and unlock new opportunities for growth, innovation, and shared success.
                            </Typography>
                            
                            {/* Contact encouragement */}
                            <Box style={{
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: isMobile ? "15px" : "30px",
                                flexWrap: "wrap"
                            }}>
                                <Box style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    background: "rgba(255,255,255,0.1)",
                                    padding: "12px 20px",
                                    borderRadius: "25px",
                                    border: "1px solid rgba(255,255,255,0.2)"
                                }}>
                                    <FlashOn style={{
                                        color: theme.palette.common.white,
                                        fontSize: isMobile ? "18px" : "20px"
                                    }} />
                                    <Typography variant="body2" style={{
                                        color: theme.palette.common.white,
                                        fontWeight: 500,
                                        fontSize: isMobile ? "0.9rem" : "1rem"
                                    }}>
                                        Speed
                                    </Typography>
                                </Box>
                                <Box style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    background: "rgba(255,255,255,0.1)",
                                    padding: "12px 20px",
                                    borderRadius: "25px",
                                    border: "1px solid rgba(255,255,255,0.2)"
                                }}>
                                    <Sync style={{
                                        color: theme.palette.common.white,
                                        fontSize: isMobile ? "18px" : "20px"
                                    }} />
                                    <Typography variant="body2" style={{
                                        color: theme.palette.common.white,
                                        fontWeight: 500,
                                        fontSize: isMobile ? "0.9rem" : "1rem"
                                    }}>
                                        Synergy
                                    </Typography>
                                </Box>
                                <Box style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    background: "rgba(255,255,255,0.1)",
                                    padding: "12px 20px",
                                    borderRadius: "25px",
                                    border: "1px solid rgba(255,255,255,0.2)"
                                }}>
                                    <EmojiEvents style={{
                                        color: theme.palette.common.white,
                                        fontSize: isMobile ? "18px" : "20px"
                                    }} />
                                    <Typography variant="body2" style={{
                                        color: theme.palette.common.white,
                                        fontWeight: 500,
                                        fontSize: isMobile ? "0.9rem" : "1rem"
                                    }}>
                                        Shared Success
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default Collaborations;